declare global {
  interface Window {
    Paytm: any;
  }
}
import { CheckIcon } from "@heroicons/react/outline";
import { ButtonBase, ModalBase } from "@reusejs/react";
import { useState } from "react";
import { createSubscription, updateSubscription } from "services";
import SuccessFailureModal from "./SuccessFailureModal";
import { useRouter } from "next/router";
import { useSelector, useDispatch } from "react-redux";
import { setSubscription, setRedirectUrl } from "store";
import LoginFormModal from "../authentication/LoginFromModal";

const pricing = {
  tiers: [
    {
      id: 1,
      title: "Forever Free",
      price: "Free",
      amount: "00",
      description: "Billed annually.",
      features: [
        "Weekly Customized Auction Property Alerts",
        "Access to wide range of auction property",
        "Virtual Assistance in Property Acquisition",
      ],
      cta: "Get Started",
      mostPopular: false,
    },
    {
      id: 2,
      title: "Popular Plan",
      price: "Rs.4,999",
      amount: "4999.00",
      description: "Billed annually.",
      features: [
        "Daily Customized property alerts",
        "Encumbrances Search Report- 20 Properties",
        "Legal Analysis and Report",
        "Virtual Tour 5 Chosen Properties",
        "Expert Consultation during Property Acquisition",
        "Price Analysis",
      ],
      cta: "Get Started",
      mostPopular: true,
    },
    {
      id: 3,
      title: "Pro Plan",
      price: "Rs.9,999",
      amount: "9999.00",
      description: "Billed annually.",
      features: [
        "Daily Customized property alerts",
        "Encumbrances Search Report- 20 Properties",
        "Price Analysis",
        "Legal Analysis and Report",
        "Expert Consultation during Property Acquisition",
        "Dedicated relationship manager",
        "Property visit assistance",
        "Free consultation upto 50 properties",
        "Assistance from identification of property till registration",
      ],
      cta: "Get Started",
      mostPopular: false,
    },
  ],
};

export default function SubscriptionCardWrapper() {
  return (
    <div className="mx-auto max-w-7xl bg-white py-12 md:py-28 px-4 md:px-6 lg:px-8">
      <div className="space-y-12 lg:grid lg:grid-cols-3 lg:gap-x-8 lg:space-y-0">
        {pricing.tiers.map((tier, index) => (
          <SubscriptionCard key={index} tier={tier} />
        ))}
      </div>
    </div>
  );
}

const SubscriptionCard = (props: any) => {
  const router: any = useRouter();
  const dispatch = useDispatch();
  const userToken = useSelector((state: any) => {
    return state.auth.accessToken;
  });

  const subscription = useSelector((state: any) => {
    return state.auth?.subscription;
  });
  const [loading, setLoading] = useState(false);

  const openModal = async (title: string, message: string, color: string) => {
    const SuccessModalWrapper = (props: any) => {
      return (
        <SuccessFailureModal
          router={router}
          heading={title}
          description={message}
          color={color}
          {...props}
        />
      );
    };

    await ModalBase(
      {
        content: SuccessModalWrapper,
        timeout: 0,
        backgroundColor: "bg-black/30",
        backgroundOpacity: "opacity-70",
        modalBaseClasses: {
          background: "bg-white",
          border: "border-2 rounded-lg",
          alignment: "z-50  overflow-visible",
          padding: "p-0",
          small: "max-w-4xl",
        },
      },
      1000,
      "__next"
    );
  };

  const LoginFormWrapper = (props: any) => {
    return <LoginFormModal router={router} {...props} />;
  };

  const openLoginModal = async () => {
    await ModalBase(
      {
        content: LoginFormWrapper,
        timeout: 0,
        backgroundColor: "bg-black/30",
        backgroundOpacity: "opacity-70",
        modalBaseClasses: {
          background: "bg-white",
          border: "border-2 rounded-lg",
          alignment: "text-left overflow-visible",
          padding: "p-0",
          small: "sm:my-8 sm:w-full sm:max-w-md",
        },
      },
      1000,
      "__next"
    );
  };

  const checkoutPage = async (plan: any) => {
    if (userToken) {
      try {
        setLoading(true);
        if (plan.id !== 1 && window !== undefined) {
          console.log("check here", plan);

          const initiateTransactionData: any = await createSubscription(plan);
          console.log("check here data::>>>", initiateTransactionData);
          if (initiateTransactionData) {
            var config = {
              root: "",
              flow: "DEFAULT",
              data: {
                orderId: initiateTransactionData.uuid,
                token:
                  initiateTransactionData.initiate_transaction_data?.body
                    ?.txnToken,
                tokenType: "TXN_TOKEN",
                amount: initiateTransactionData.amount,
              },
              merchant: {
                redirect: false,
              },
              handler: {
                notifyMerchant: function (eventName: any, data: any) {},
                transactionStatus: async function (data: any) {
                  if (data.STATUS === "TXN_SUCCESS") {
                    let paymentData = {
                      initial_transaction_data:
                        initiateTransactionData.initiate_transaction_data,
                      payment_data: data,
                    };
                    initiateTransactionData["pg_data"] = paymentData;
                    initiateTransactionData["status"] = "active";
                    initiateTransactionData["payment_status"] = "paid";

                    window.Paytm.CheckoutJS.close();
                    await updateSubscription(initiateTransactionData);

                    dispatch(setSubscription(initiateTransactionData));

                    openModal(
                      "Payment Success!",
                      "Your payment is successful and subscription has activated.",
                      "bg-green-50 text-green-500"
                    );
                  }

                  if (data.STATUS === "TXN_FAILURE") {
                    window.Paytm.CheckoutJS.close();
                    openModal(
                      "Payment Failed!",
                      data.RESPMSG,
                      "bg-red-50 text-red-500"
                    );
                  }
                },
              },
            };
            if (window.Paytm && window.Paytm.CheckoutJS) {
              window.Paytm.CheckoutJS.init(config)
                .then(function onSuccess() {
                  window.Paytm.CheckoutJS.invoke();
                })
                .catch(function onError(error: any) {
                  console.log("error => ", error);
                });
            }
          }
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.log("error:::", error);
      }
    } else {
      dispatch(setRedirectUrl(router.pathname));
      openLoginModal();
    }
  };
  return (
    <div
      key={props.tier.title}
      className="relative flex flex-col rounded-2xl border border-gray-200 bg-white p-8 shadow-sm"
    >
      <div className="flex-1">
        {props.tier.mostPopular ? (
          <p className="absolute top-0 -translate-y-1/2 transform rounded-full bg-blue-500 py-1.5 px-4 text-sm font-semibold text-white">
            Most popular
          </p>
        ) : null}
        <p className="mt-2 flex justify-center items-baseline text-gray-900">
          <span className="text-5xl text-center font-semibold md:font-bold tracking-tight">
            {props.tier.price}
          </span>
        </p>
        <h3 className="mt-4 text-lg md:text-xl text-center font-semibold text-gray-900">
          {props.tier.title}
        </h3>
        <p className="text-sm md:text-base text-center text-gray-500">
          {props.tier.description}
        </p>
        <ul role="list" className="mt-6 space-y-4">
          {props.tier.features.map((feature: any) => (
            <li key={feature} className="flex items-center justify-start">
              <div className="flex h-5 w-5 md:h-6 md:w-6 items-center justify-center rounded-full bg-green-100">
                <CheckIcon
                  className="h-5 w-5 md:h-6 md:w-6 text-green-600"
                  aria-hidden="true"
                />
              </div>
              <span className="ml-3 text-gray-500">{feature}</span>
            </li>
          ))}
        </ul>
      </div>

      <div className="mt-8 w-full py-3">
        <ButtonBase
          variant="primary"
          type="button"
          busyText={"Processing..."}
          busy={loading}
          disabled={subscription && true}
          label={props.tier.cta}
          onClick={() => checkoutPage(props.tier)}
          buttonBaseClasses={{
            font: "text-sm font-medium",
            backgroundColor: "bg-blue-600 hover:bg-blue-700",
            textColor: "text-white",
            border: "any",
            width: "w-full",
            padding: "px-4 py-3",
          }}
        />
      </div>
    </div>
  );
};
